import { STORAGE_KEYS } from '@/2D3DEditer/storage/storageKeys'

/**
 * Raw JSON persistence boundary for the legacy input wizard draft.
 * Parsing failures intentionally remain a missing draft for compatibility.
 *
 * @param {import('@/2D3DEditer/ports/storagePort').StoragePort} storagePort
 */
export function createInputDraftRepository(storagePort) {
  return {
    loadInputDraft(idempotencyKey) {
      const raw = storagePort.getItem(STORAGE_KEYS.inputDraft(idempotencyKey))
      if (!raw) return null
      try {
        return JSON.parse(raw)
      } catch (error) {
        return null
      }
    },

    saveInputDraft(idempotencyKey, draft) {
      storagePort.setItem(STORAGE_KEYS.inputDraft(idempotencyKey), JSON.stringify(draft || {}))
    },

    clearInputDraft(idempotencyKey) {
      storagePort.removeItem(STORAGE_KEYS.inputDraft(idempotencyKey))
    }
  }
}